var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "leak-investigation-reports" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-lg-12" },
        [
          _vm._m(0),
          _vm._v(" "),
          _c(_setup.LeakInvestigationReportsSearchFilters, {
            attrs: {
              filters: _setup.filters,
              loading: _setup.loading,
              "exporting-csv": _setup.exportingCsv,
              "total-reports": _setup.totalReports,
            },
            on: {
              "update-filters": _setup.handleFiltersUpdate,
              search: _setup.loadLeakInvestigationReports,
              "export-csv": _setup.handleExportCsv,
            },
          }),
          _vm._v(" "),
          _setup.loading
            ? _c("div", { staticClass: "text-center my-4" }, [_vm._m(1)])
            : _vm._e(),
          _vm._v(" "),
          _setup.error
            ? _c(
                "b-alert",
                {
                  attrs: {
                    show: !!_setup.error,
                    variant: "danger",
                    dismissible: "",
                  },
                  on: {
                    dismissed: function ($event) {
                      _setup.error = null
                    },
                  },
                },
                [
                  _c("strong", [_vm._v("Error:")]),
                  _vm._v(" " + _vm._s(_setup.error) + "\n      "),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_setup.loading
            ? _c(_setup.LeakInvestigationReportsTable, {
                attrs: {
                  "leak-investigation-reports": _setup.leakInvestigationReports,
                  "download-states": _setup.downloadStates,
                  "sort-by": _setup.sortField,
                  "sort-desc": _setup.sortDirection === "desc",
                },
                on: {
                  download: _setup.handleDownload,
                  sort: _setup.handleSort,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          !_setup.loading && _setup.leakInvestigationReports.length > 0
            ? _c(
                "div",
                { staticClass: "mt-3" },
                [
                  _c("b-pagination", {
                    staticClass: "my-0",
                    attrs: {
                      "total-rows": _setup.totalReports,
                      "per-page": _setup.pageSize,
                      align: "center",
                      size: "md",
                    },
                    on: { change: _setup.handlePageChange },
                    model: {
                      value: _setup.pageCurrent,
                      callback: function ($$v) {
                        _setup.pageCurrent = $$v
                      },
                      expression: "pageCurrent",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      { staticClass: "d-flex justify-content-between align-items-center mb-3" },
      [
        _c("h1", { staticClass: "lbv-page-title pb-0" }, [
          _vm._v("\n          Claims Mitigation Reports\n        "),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      { staticClass: "spinner-border text-primary", attrs: { role: "status" } },
      [
        _c("span", { staticClass: "sr-only" }, [
          _vm._v("Loading Claims Mitigation Reports..."),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }